import { translationConstants } from "../../../constants";
import { replaceSportsIdWithName } from "../../../system";

export const getSpotTypes = (t) => {
  return [
    { id: 0, value: "pubic", label: t(translationConstants.PUBLIC_SPOT) },
    {
      id: 1,
      value: "private",
      label: t(translationConstants.PRIVATE_SPOT),
    },
  ];
};

export const getSportsAsAString = (t, sports) => {
  return replaceSportsIdWithName(sports, t);
};